export interface FeedbackModel {
  smartNumber: string;
  description: string;
  shortDescription: FEEDBACK_SHORT_DESCRIPTION[] | string[];
  message: string;
  feedbackSource: FEEDBACK_SOURCE.ADMIN | FEEDBACK_SOURCE.CLIENT;
  negative: boolean;
  author?: string;
  voteTime?: string;
  pageLink?: string;
  productName?: string;
  productVersion?: string;
  servicePackName?: string;
  feedbackType?: FEEDBACK_FORM_TYPE.NEGATIVE | FEEDBACK_FORM_TYPE.POSITIVE;
}

export enum FEEDBACK_FORM_TYPE {
  NEGATIVE  = 'NEGATIVE',
  POSITIVE =  'POSITIVE',
  COLLAPSED = 'COLLAPSED'
}
export enum FEEDBACK_SHORT_DESCRIPTION {
  DIFFICULT_TO_USE = 'DIFFICULT_TO_USE',
  MISSING_INFO = 'MISSING_INFO',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  APP_NOT_WORKING_AS_EXPECTED = 'APP_NOT_WORKING_AS_EXPECTED'
}

export enum FEEDBACK_SOURCE {
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT'
}

export enum FEEDBACK_API_ACTIONS {
  CREATE = 'feedback',
  GET_ALL_FEEDBACK = 'feedback',
  GET_PRODUCT_FEEDBACK = 'product/feedback',
  GET_ADMIN = 'admin',
  GET_CLIENT = 'client'
}

export enum FEEDBACK_LOCATION {
  SEARCH = 'SEARCH'
}
